export const addEventListenerOnce = (element, type, listener) => {
	element.addEventListener(type, function fn(event) {
		element.removeEventListener(type, fn);
		listener(event);
	});
};
